import captionService, { type Caption } from "CaptionService";
import widgetFactory from "WidgetFactory";
import widgetUtils from "WidgetUtils";
import $ from "jquery";

/*! SuppressStringValidation CSS class name */
const testClassName = "g-label-tester";

class CaptionPresentationService {
  getCaptionThatFits($elementToTestWith: JQuery, captionsToTest: string[], maxWidth: number): string {
    return getCaptionThatFits($elementToTestWith, captionsToTest, () => maxWidth);
  }

  resizeCaptionForWidget($label: JQuery, caption: Caption): void {
    const availableWidthGetter = (): number | undefined => $label.parent().width();
    const captionsToTest = [caption.short, caption.medium, caption.long];
    const captionThatFits = getCaptionThatFits($label, captionsToTest, availableWidthGetter);
    setCaption($label, captionThatFits);
  }

  resizeCaptions($context: JQuery): void {
    widgetFactory.select($context, /*includeSelf:*/ true).each((_, element) => {
      this.resizeCaption(widgetUtils.getLabelForElement($(element)));
    });
  }

  resizeCaption($label: JQuery): void {
    if ($label && $label.length) {
      let caption = $label.data("captionDetail");

      if (caption) {
        if (caption.ResKey) {
          caption = captionService.getCaptionFromKey(caption.ResKey, caption.Fallback);
        }

        this.resizeCaptionForWidget($label, caption);
      }
    }
  }
}

function getCaptionThatFits(
  $elementToTestWith: JQuery,
  captionsToTest: (string | undefined)[],
  maxWidthGetter: () => number | undefined,
): string {
  const filteredCaptionsToTest = captionsToTest.filter((caption): caption is string => !!caption);
  if (!filteredCaptionsToTest.length) {
    return "";
  } else if (filteredCaptionsToTest.length === 1) {
    return filteredCaptionsToTest[0];
  }

  let captionThatFits = filteredCaptionsToTest[0];
  const maxWidth = maxWidthGetter() ?? 0;
  $elementToTestWith.addClass(testClassName);
  for (let i = 1; i < filteredCaptionsToTest.length; i++) {
    const captionToTest = filteredCaptionsToTest[i];
    setCaption($elementToTestWith, captionToTest);
    const textWidth = $elementToTestWith.outerWidth() ?? 0;
    if (textWidth <= maxWidth) {
      captionThatFits = captionToTest;
    }
    if (textWidth >= maxWidth) {
      break;
    }
  }
  $elementToTestWith.removeClass(testClassName);

  return captionThatFits;
}

function setCaption($label: JQuery, caption: string): void {
  $label.html(caption);
}

export default new CaptionPresentationService();
